__turbopack_context__.v({
  "cancelBtn": "forget-password-module__VOEOVa__cancelBtn",
  "forgetPasswordContainer": "forget-password-module__VOEOVa__forgetPasswordContainer",
  "forgetPassworldOverylay": "forget-password-module__VOEOVa__forgetPassworldOverylay",
  "forgotPasswordTitle": "forget-password-module__VOEOVa__forgotPasswordTitle",
  "sendCodeBtn": "forget-password-module__VOEOVa__sendCodeBtn",
  "signInInfo": "forget-password-module__VOEOVa__signInInfo",
});
